export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  { code: 'zh-TW', name: 'Traditional Chinese', nativeName: '繁體中文' },
  { code: 'zh-CN', name: 'Simplified Chinese', nativeName: '简体中文' }
];

export const translations = {
  en: {
    // Navigation tabs
    tabs: {
      guide: 'Guide',
      single: 'Single',
      spread: 'Spread',
      cards: 'Cards',
      saved: 'Saved'
    },

    // App header
    app: {
      title: 'Galactic Heritage Cards'
    },

    // Settings drawer
    settings: {
      title: 'Settings',
      language: 'Language',
      background: 'Background',
      starlink: 'Star link',
      star: 'Star',
      static: 'Static',
      fun: "Let's have some fun",
      portal: 'Portal',
      amongUs: 'Among us',
      exportImport: 'Export / Import',
      copySaved: 'Copy Saved to Clipboard',
      importSaved: 'Import Saved Items',
      pastePlaceholder: 'Paste saved items here...',
      copying: 'Copying...',
      savedCopied: '{{count}} saved items copied',
      savedWritten: '{{count}} saved items written, please copy from textbox',
      zeroSavedWritten: '0 saved item written',
      importing: 'Importing...',
      invalidString: 'Invalid string: {{preview}}...',
      importFailed: 'Import failed: {{error}}',
      addedOneItem: 'Added 1 saved item',
      addedMultipleItems: 'Added {{count}} saved items'
    },

    // Common actions & UI
    common: {
      next: 'Next',
      previous: 'Previous',
      shuffle: 'Shuffle',
      saveNotes: 'Save | Notes',
      notes: 'Notes',
      done: 'Done',
      commentary: 'Commentary',
      back: 'Back',
      cannotReadGuide: 'Cannot read guide config',
      search: 'Search',
      cannotReadCard: 'Cannot read card {{card}}'
    },

    // Single card view
    single: {
      shuffle: 'Shuffle',
      saveNotes: 'Save | Notes',
      notes: 'Notes'
    },

    // Cards list / gallery
    cards: {
      searchPlaceholder: 'Card#',
      fragments: 'Fragments',
      timeline: 'Timeline',
      categories: {
        'Founders': 'Founders',
        'Arcturus': 'Arcturus',
        'Andromeda': 'Andromeda',
        'Lyra': 'Lyra',
        'Vega': 'Vega',
        'Orion & Orion Light': 'Orion & Orion Light',
        'Pleiades': 'Pleiades',
        'Sirius': 'Sirius',
        'Zeta Reticuli': 'Zeta Reticuli',
        'Earth': 'Earth',
        'Essassani': 'Essassani',
        'Cetacean Dolphin & Whale': 'Cetacean Dolphin & Whale',
        'Hybrid': 'Hybrid',
        'Reptilian': 'Reptilian',
        'Insectoid': 'Insectoid',
        'Non-humanoid': 'Non-humanoid',
        'Solar System': 'Solar System',
        'Galactic Core': 'Galactic Core',
        'Association of Worlds': 'Association of Worlds'
      },
      timelines: {
        'Past': 'Past',
        'Present': 'Present',
        'Future': 'Future',
        'Parallel': 'Parallel'
      }
    },

    // Saved view
    saved: {
      newest: 'Newest',
      oldest: 'Oldest',
      edit: 'Edit',
      done: 'Done',
      noSaved: 'No saved item.'
    },

    // Notes popup
    noteModal: {
      title: 'Notes',
      done: 'Done',
      titlePlaceholder: 'Title',
      contentPlaceholder: 'My question, my notes ...'
    },

    // Spreads
    spreads: {
      header: 'Layout',
      starlineage: {
        title: 'Star Lineage Spread',
        desc: 'What stellar influences are working with you now?'
      },
      karmic: {
        title: 'Karmic Challenges Spread',
        desc: 'What karmic challenges may be affecting you now?'
      },
      higher: {
        title: 'Higher Guidance Spread',
        desc: 'Receive guidance from the Universe applicable to your current life.'
      },
      personal: {
        title: 'Personal Questions',
        desc: 'A dynamic view of your present situation.'
      },
      current: {
        title: 'Current Influences Spread',
        desc: 'The current influences of your present situation.'
      },
      chakra: {
        title: 'Chakra Spread',
        desc: 'Use this experimental chakra spread to get a picture of your mental, emotional, physical, and spiritual balance.',
        showInstructions: 'Show instructions',
        closeInstructions: 'Close instructions'
      },
      free: {
        title: 'Free-form',
        desc: 'Create your own card spread!'
      }
    },

    // Chakra spread specific
    chakraSpread: {
      title: 'Chakra Spread',
      infoTitle: 'The Chakra Spread',
      instruction: 'The chakra spread is experimental. Germane said it should be fluid, so we recommend that after viewing the cards, intuitively sense one “anchor “ card that feels like a perfect fit for you in a particular chakra space. Spin the wheel to lock it in there, and then read the rest of the cards according to how they are now placed. You can also read each card in each position as you move the wheel clockwise for deeper and more complete guidance for each chakra.',
      sevenChakras: 'The Seven Chakras',
      labels: ['Root', 'Sacral', 'Solar\nPlexus', 'Heart', 'Throat', 'Third\nEye', 'Crown'],
      positions: ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th'],
      chakras: [
        { name: '1st - Root:', desc: 'Grounding. Embracing human life.' },
        { name: '2nd - Sacral:', desc: 'Male/Female balance. Creativity. Sexual energy. Emotional wounds.' },
        { name: '3rd - Solar Plexus:', desc: 'Use of the will. Control issues. Bringing energy/ideas to fruition' },
        { name: '4th - Heart:', desc: 'Unconditional love for self and others. Openness. Receiving & giving.' },
        { name: '5th - Throat:', desc: 'Channeling, communication, relationship with others.' },
        { name: '6th - Third Eye:', desc: 'Psychic ability, inner vision, seeing beyond 3D illusion.' },
        { name: '7th - Crown:', desc: 'Spiritual connection to the universe. Beyond singular identity.' }
      ]
    },

    // Free spread specific
    freeSpread: {
      layout: 'Layout',
      viewing: 'Viewing'
    }
  },

  ja: {
    // Navigation tabs
    tabs: {
      guide: 'ガイド',
      single: 'シングル',
      spread: 'スプレッド',
      cards: 'カード一覧',
      saved: '保存済み'
    },

    // App header
    app: {
      title: '星際伝承カード'
    },

    // Settings drawer
    settings: {
      title: '設定',
      language: '言語',
      background: '背景エフェクト',
      starlink: 'スターリンク',
      star: '星空',
      static: '静止',
      fun: 'お楽しみ演出',
      portal: 'ポータル',
      amongUs: '宇宙飛行士',
      exportImport: 'エクスポート / インポート',
      copySaved: '保存した項目をクリップボードにコピー',
      importSaved: '保存項目をインポート',
      pastePlaceholder: 'ここに保存データを貼り付けてください...',
      copying: 'コピー中...',
      savedCopied: '{{count}}件の保存項目をコピーしました',
      savedWritten: '{{count}}件の保存データをテキストボックスに出力しました。コピーしてください',
      zeroSavedWritten: '保存データが0件です',
      importing: 'インポート中...',
      invalidString: '無効な文字列です: {{preview}}...',
      importFailed: 'インポートに失敗しました: {{error}}',
      addedOneItem: '1件の保存項目を追加しました',
      addedMultipleItems: '{{count}}件の保存項目を追加しました'
    },

    // Common actions & UI
    common: {
      next: '次へ',
      previous: '前へ',
      shuffle: 'シャッフル',
      saveNotes: '保存 | メモ',
      notes: 'メモ',
      done: '完了',
      commentary: '解説',
      back: '戻る',
      cannotReadGuide: 'ガイドの設定を読み込めません',
      search: '検索',
      cannotReadCard: 'カード {{card}} を読み込めません'
    },

    // Single card view
    single: {
      shuffle: 'シャッフル',
      saveNotes: '保存 | メモ',
      notes: 'メモ'
    },

    // Cards list / gallery
    cards: {
      searchPlaceholder: 'カード番号',
      fragments: 'フラグメント（起源）',
      timeline: 'タイムライン（時代）',
      categories: {
        'Founders': '創造の創始者（ファウンダーズ）',
        'Arcturus': 'アルクトゥルス',
        'Andromeda': 'アンドロメダ',
        'Lyra': 'こと座（ライラ）',
        'Vega': 'ベガ',
        'Orion & Orion Light': 'オリオン＆オリオン・ライト',
        'Pleiades': 'プレアデス',
        'Sirius': 'シリウス',
        'Zeta Reticuli': 'ゼータ・レチクル',
        'Earth': '地球',
        'Essassani': 'エササニ',
        'Cetacean Dolphin & Whale': '鯨類（イルカ＆クジラ）',
        'Hybrid': 'ハイブリッド',
        'Reptilian': '爬虫類型（レプティリアン）',
        'Insectoid': '昆虫類型（インセクトイド）',
        'Non-humanoid': '非ヒューマノイド',
        'Solar System': '太陽系',
        'Galactic Core': '銀河の中心（コア）',
        'Association of Worlds': '惑星連合'
      },
      timelines: {
        'Past': '過去',
        'Present': '現在',
        'Future': '未来',
        'Parallel': 'パラレル'
      }
    },

    // Saved view
    saved: {
      newest: '新しい順',
      oldest: '古い順',
      edit: '編集',
      done: '完了',
      noSaved: '保存されたアイテムはありません。'
    },

    // Notes popup
    noteModal: {
      title: 'メモ',
      done: '完了',
      titlePlaceholder: 'タイトル',
      contentPlaceholder: '質問や気付き、メモを入力...'
    },

    // Spreads
    spreads: {
      header: 'スプレッド',
      starlineage: {
        title: 'スター・リネージ・スプレッド',
        desc: '現在どのような星のエネルギーがあなたと共にあるかを探ります。'
      },
      karmic: {
        title: 'カルミック・チャレンジ・スプレッド',
        desc: '現在影響を与えているカルマの課題を浮き彫りにします。'
      },
      higher: {
        title: 'ハイアー・ガイダンス・スプレッド',
        desc: '現在の人生に活かせる宇宙からの高次元ガイダンスを受け取ります。'
      },
      personal: {
        title: 'パーソナル・クエスチョン',
        desc: 'あなたが抱える特定のテーマや状況を深く見つめるスプレッドです。'
      },
      current: {
        title: 'カレント・インフルエンス・スプレッド',
        desc: '現在の状況に働いているダイナミックな影響力を明らかにします。'
      },
      chakra: {
        title: 'チャクラ・スプレッド',
        desc: '精神・感情・身体・霊性のバランスを把握するための実験的スプレッドです。',
        showInstructions: '説明を表示',
        closeInstructions: '説明を閉じる'
      },
      free: {
        title: 'フリーフォーム',
        desc: 'カードを自由に配置して独自のスプレッドを作成できます！'
      }
    },

    // Chakra spread specific
    chakraSpread: {
      title: 'チャクラ・スプレッド',
      infoTitle: 'チャクラ・スプレッドについて',
      instruction: 'チャクラ・スプレッドは実験的な手法です。ジャーメインによると、これは流動的なものであるべきとされています。カードを開いた後、直感的に特定のチャクラの位置にしっくりくる「アンカー」カードを1枚見つけてみてください。ホイールを回転させてそのカードを合わせ、残りのカードがどの位置に来たかを読み解きます。また、ホイールを時計回りに回しながら、各チャクラにおける各カードの位置を読んでいくことで、より深い洞察を得ることもできます。',
      sevenChakras: '7つのチャクラ',
      labels: ['ルート', 'セイクラル', 'ソーラー\nプレクサス', 'ハート', 'スロート', 'サード\nアイ', 'クラウン'],
      positions: ['第1', '第2', '第3', '第4', '第5', '第6', '第7'],
      chakras: [
        { name: '第1 - ルート（基底）:', desc: 'グラウンディング。地球と物質次元への定着。' },
        { name: '第2 - セイクラル（仙骨）:', desc: '男性性と女性性のバランス。創造力。セクシャリティ。感情の癒し。' },
        { name: '第3 - ソーラープレクサス（太陽神経叢）:', desc: '意志の行使。コントロールの課題。アイデアの具現化。' },
        { name: '第4 - ハート（心臓）:', desc: '自他への無条件の愛。受容と与えること。心の開放。' },
        { name: '第5 - スロート（喉）:', desc: 'チャネリング、真実の表現、他者とのコミュニケーション。' },
        { name: '第6 - サードアイ（第三の目）:', desc: '直感力、内なる視力、三次元の幻想を超えて真実を見る力。' },
        { name: '第7 - クラウン（頭頂）:', desc: '宇宙との霊的結合。個のアイデンティティを超越したワンネス。' }
      ]
    },

    // Free spread specific
    freeSpread: {
      layout: '配置モード',
      viewing: '閲覧モード'
    }
  },

  'zh-TW': {
    // Navigation tabs
    tabs: {
      guide: '指南',
      single: '單張',
      spread: '牌陣',
      cards: '卡牌',
      saved: '已儲存'
    },

    // App header
    app: {
      title: '星際傳承牌卡'
    },

    // Settings drawer
    settings: {
      title: '設定',
      language: '語言',
      background: '背景效果',
      starlink: '星際連結',
      star: '星空',
      static: '靜態',
      fun: '探索樂趣',
      portal: '傳送門',
      amongUs: '太空漫遊',
      exportImport: '匯出 / 匯入',
      copySaved: '複製已儲存項目到剪貼簿',
      importSaved: '匯入已儲存項目',
      pastePlaceholder: '在此貼上已儲存的資料...',
      copying: '複製中...',
      savedCopied: '已複製 {{count}} 個儲存項目',
      savedWritten: '已將 {{count}} 個儲存項目寫入文字方塊，請手動複製',
      zeroSavedWritten: '已寫入 0 個項目',
      importing: '匯入中...',
      invalidString: '無效的字串: {{preview}}...',
      importFailed: '匯入失敗: {{error}}',
      addedOneItem: '已新增 1 個儲存項目',
      addedMultipleItems: '已新增 {{count}} 個儲存項目'
    },

    // Common actions & UI
    common: {
      next: '下一頁',
      previous: '上一頁',
      shuffle: '洗牌',
      saveNotes: '儲存 | 筆記',
      notes: '筆記',
      done: '完成',
      commentary: '解讀',
      back: '返回',
      cannotReadGuide: '無法讀取指南設定',
      search: '搜尋',
      cannotReadCard: '無法讀取卡片 {{card}}'
    },

    // Single card view
    single: {
      shuffle: '洗牌',
      saveNotes: '儲存 | 筆記',
      notes: '筆記'
    },

    // Cards list / gallery
    cards: {
      searchPlaceholder: '卡號',
      fragments: '碎片族群（種族起源）',
      timeline: '時間線（紀元）',
      categories: {
        'Founders': '創始者（Founders）',
        'Arcturus': '大角星（Arcturus）',
        'Andromeda': '仙女座（Andromeda）',
        'Lyra': '天琴座（Lyra）',
        'Vega': '織女星（Vega）',
        'Orion & Orion Light': '獵戶座與獵戶之光（Orion & Orion Light）',
        'Pleiades': '昴宿星（Pleiades）',
        'Sirius': '天狼星（Sirius）',
        'Zeta Reticuli': '齊塔網罟星（Zeta Reticuli）',
        'Earth': '地球（Earth）',
        'Essassani': '愛莎莎尼（Essassani）',
        'Cetacean Dolphin & Whale': '鯨豚族（海豚與鯨魚）',
        'Hybrid': '混血種族（Hybrid）',
        'Reptilian': '爬蟲族（Reptilian）',
        'Insectoid': '昆蟲族（Insectoid）',
        'Non-humanoid': '非人形族（Non-humanoid）',
        'Solar System': '太陽系（Solar System）',
        'Galactic Core': '銀河中心（Galactic Core）',
        'Association of Worlds': '世界聯盟（Association of Worlds）'
      },
      timelines: {
        'Past': '過去',
        'Present': '現在',
        'Future': '未來',
        'Parallel': '平行'
      }
    },

    // Saved view
    saved: {
      newest: '最新優先',
      oldest: '最舊優先',
      edit: '編輯',
      done: '完成',
      noSaved: '尚無已儲存的卡牌項目。'
    },

    // Notes popup
    noteModal: {
      title: '筆記',
      done: '完成',
      titlePlaceholder: '標題',
      contentPlaceholder: '輸入您的問題、心得或筆記...'
    },

    // Spreads
    spreads: {
      header: '牌陣佈局',
      starlineage: {
        title: '星際傳承牌陣',
        desc: '探索當下正在與您共振並協作的星際能量影響。'
      },
      karmic: {
        title: '業力挑戰牌陣',
        desc: '檢視目前可能對您產生影響的業力課題與挑戰。'
      },
      higher: {
        title: '高維指引牌陣',
        desc: '接收來自宇宙對您當前人生實相的深刻指引。'
      },
      personal: {
        title: '個人問題牌陣',
        desc: '全方位、動態地剖析您當下所面臨的特定情境。'
      },
      current: {
        title: '當前影響牌陣',
        desc: '洞察塑造您現況的當前各方影響力。'
      },
      chakra: {
        title: '脈輪牌陣',
        desc: '運用此實驗性脈輪牌陣，檢視心智、情緒、肉體與靈性的全面平衡。',
        showInstructions: '顯示說明',
        closeInstructions: '關閉說明'
      },
      free: {
        title: '自訂自由牌陣',
        desc: '隨心擺放卡牌，打造專屬於您的獨特牌陣！'
      }
    },

    // Chakra spread specific
    chakraSpread: {
      title: '脈輪牌陣',
      infoTitle: '脈輪牌陣說明',
      instruction: '脈輪牌陣是一個實驗性的牌陣。哲曼（Germane）指出此能量應當是流動的，因此建議在翻開卡牌後，依憑直覺感受哪一張「錨定卡」與某個特定脈輪最為契合。旋轉轉盤將其鎖定在該位置，然後按照當前的排列順序解讀其餘卡牌。您也可以順時針轉動輪盤，逐一檢視各位置上的卡牌，以獲得針對各個脈輪更深入且完整的指引。',
      sevenChakras: '七大脈輪',
      labels: ['海底輪', '本我輪', '太陽\n神經叢', '心輪', '喉輪', '眉心輪', '頂輪'],
      positions: ['第1', '第2', '第3', '第4', '第5', '第6', '第7'],
      chakras: [
        { name: '第1 - 海底輪（Root）:', desc: '扎根大地。全然擁抱人類物質生活。' },
        { name: '第2 - 本我輪（Sacral）:', desc: '陰陽平衡。創造力。性與生命能量。情緒創傷的療癒。' },
        { name: '第3 - 太陽神經叢（Solar Plexus）:', desc: '意志的運用。掌控議題。將靈感轉化為實體果實。' },
        { name: '第4 - 心輪（Heart）:', desc: '對自己與他人的無條件之愛。敞開接納與無私給予。' },
        { name: '第5 - 喉輪（Throat）:', desc: '通靈通道、真實表達、與他人的溝通關係。' },
        { name: '第6 - 眉心輪（Third Eye）:', desc: '心靈直覺力、內在洞見、看透三維幻相的智慧。' },
        { name: '第7 - 頂輪（Crown）:', desc: '與浩瀚宇宙的靈性聯結。超越單一自我認同的合一。' }
      ]
    },

    // Free spread specific
    freeSpread: {
      layout: '排版模式',
      viewing: '檢視模式'
    }
  },

  'zh-CN': {
    // Navigation tabs
    tabs: {
      guide: '指南',
      single: '单张',
      spread: '牌阵',
      cards: '卡牌',
      saved: '已保存'
    },

    // App header
    app: {
      title: '星际传承牌卡'
    },

    // Settings drawer
    settings: {
      title: '设置',
      language: '语言',
      background: '背景效果',
      starlink: '星际连接',
      star: '星空',
      static: '静态',
      fun: '探索乐趣',
      portal: '传送门',
      amongUs: '太空漫游',
      exportImport: '导出 / 导入',
      copySaved: '复制已保存项目到剪贴板',
      importSaved: '导入已保存项目',
      pastePlaceholder: '在此粘贴已保存的数据...',
      copying: '复制中...',
      savedCopied: '已复制 {{count}} 个保存项目',
      savedWritten: '已将 {{count}} 个保存项目写入文本框，请手动复制',
      zeroSavedWritten: '已写入 0 个项目',
      importing: '导入中...',
      invalidString: '无效的字符串: {{preview}}...',
      importFailed: '导入失败: {{error}}',
      addedOneItem: '已添加 1 个保存项目',
      addedMultipleItems: '已添加 {{count}} 个保存项目'
    },

    // Common actions & UI
    common: {
      next: '下一页',
      previous: '上一页',
      shuffle: '洗牌',
      saveNotes: '保存 | 笔记',
      notes: '笔记',
      done: '完成',
      commentary: '解读',
      back: '返回',
      cannotReadGuide: '无法读取指南配置',
      search: '搜索',
      cannotReadCard: '无法读取卡片 {{card}}'
    },

    // Single card view
    single: {
      shuffle: '洗牌',
      saveNotes: '保存 | 笔记',
      notes: '笔记'
    },

    // Cards list / gallery
    cards: {
      searchPlaceholder: '卡号',
      fragments: '碎片族群（种族起源）',
      timeline: '时间线（纪元）',
      categories: {
        'Founders': '创始者（Founders）',
        'Arcturus': '大角星（Arcturus）',
        'Andromeda': '仙女座（Andromeda）',
        'Lyra': '天琴座（Lyra）',
        'Vega': '织女星（Vega）',
        'Orion & Orion Light': '猎户座与猎户之光（Orion & Orion Light）',
        'Pleiades': '昴宿星（Pleiades）',
        'Sirius': '天狼星（Sirius）',
        'Zeta Reticuli': '齐塔网罟星（Zeta Reticuli）',
        'Earth': '地球（Earth）',
        'Essassani': '爱莎莎尼（Essassani）',
        'Cetacean Dolphin & Whale': '鲸豚族（海豚与鲸鱼）',
        'Hybrid': '混血种族（Hybrid）',
        'Reptilian': '爬虫族（Reptilian）',
        'Insectoid': '昆虫族（Insectoid）',
        'Non-humanoid': '非人形族（Non-humanoid）',
        'Solar System': '太阳系（Solar System）',
        'Galactic Core': '银河中心（Galactic Core）',
        'Association of Worlds': '世界联盟（Association of Worlds）'
      },
      timelines: {
        'Past': '过去',
        'Present': '现在',
        'Future': '未来',
        'Parallel': '平行'
      }
    },

    // Saved view
    saved: {
      newest: '最新优先',
      oldest: '最早优先',
      edit: '编辑',
      done: '完成',
      noSaved: '暂无已保存的卡牌项目。'
    },

    // Notes popup
    noteModal: {
      title: '笔记',
      done: '完成',
      titlePlaceholder: '标题',
      contentPlaceholder: '输入您的问题、心得或笔记...'
    },

    // Spreads
    spreads: {
      header: '牌阵布局',
      starlineage: {
        title: '星际传承牌阵',
        desc: '探索当下正在与您共鸣并协作的星际能量影响。'
      },
      karmic: {
        title: '业力挑战牌阵',
        desc: '检视目前可能对您产生影响的业力课题与挑战。'
      },
      higher: {
        title: '高维指引牌阵',
        desc: '接收来自宇宙对您当前人生实相的深刻指引。'
      },
      personal: {
        title: '个人问题牌阵',
        desc: '全方位、动态地剖析您当下所面临的特定情境。'
      },
      current: {
        title: '当前影响牌阵',
        desc: '洞察塑造您现况的当前各方影响力。'
      },
      chakra: {
        title: '脉轮牌阵',
        desc: '运用此实验性脉轮牌阵，检视心智、情绪、肉体与灵性的全面平衡。',
        showInstructions: '显示说明',
        closeInstructions: '关闭说明'
      },
      free: {
        title: '自定义自由牌阵',
        desc: '随心摆放卡牌，打造专属于您的独特牌阵！'
      }
    },

    // Chakra spread specific
    chakraSpread: {
      title: '脉轮牌阵',
      infoTitle: '脉轮牌阵说明',
      instruction: '脉轮牌阵是一个实验性的牌阵。哲曼（Germane）指出此能量应当是流动的，因此建议在翻开卡牌后，凭借直觉感受哪一张“锚定卡”与某个特定脉轮最为契合。旋转转盘将其锁定在该位置，然后按照当前的排列顺序解读其余卡牌。您也可以顺时针转动轮盘，逐一检视各位置上的卡牌，以获得针对各个脉轮更深入且完整的指引。',
      sevenChakras: '七大脉轮',
      labels: ['海底轮', '本我轮', '太阳\n神经丛', '心轮', '喉轮', '眉心轮', '顶轮'],
      positions: ['第1', '第2', '第3', '第4', '第5', '第6', '第7'],
      chakras: [
        { name: '第1 - 海底轮（Root）:', desc: '扎根大地。全然拥抱人类物质生活。' },
        { name: '第2 - 本我轮（Sacral）:', desc: '阴阳平衡。创造力。性与生命能量。情绪创伤的疗愈。' },
        { name: '第3 - 太阳神经丛（Solar Plexus）:', desc: '意志的运用。掌控议题。将灵感转化为实体果实。' },
        { name: '第4 - 心轮（Heart）:', desc: '对自他的无条件之爱。敞开接纳与无私给予。' },
        { name: '第5 - 喉轮（Throat）:', desc: '通灵通道、真实表达、与他人的沟通关系。' },
        { name: '第6 - 眉心轮（Third Eye）:', desc: '心灵直觉力、内在洞见、看透三维幻相的智慧。' },
        { name: '第7 - 顶轮（Crown）:', desc: '与浩瀚宇宙的灵性联结。超越单一自我认同的合一。' }
      ]
    },

    // Free spread specific
    freeSpread: {
      layout: '排版模式',
      viewing: '查看模式'
    }
  }
};
